
import { defineComponent } from "vue";
import { useAppConfig } from "@/config";
import MapMasterController from "@/components/drawers/right/MapMasterController.vue";
import DataFilters from "@/components/drawers/right/DataFilters.vue";
import { useAuth, useLayout } from "@/services";
import { mapState } from "pinia";

const { menuTop, menuRight } = useAppConfig();

export default defineComponent({
  name: "RightSidebar",
  components: {
    MapMasterController,
    DataFilters,
  },
  data: () => ({
    menuTop,
    menuRight,
  }),
  computed: {
    ...mapState(useLayout, ["page", "rightSidebarIndex", "isMapPage"]),
    isLoggedIn(): boolean {
      return useAuth().isLoggedIn;
    },
    isVisible: {
      get(): boolean {
        return useLayout().isRightSidebarOpen;
      },
      set(value: boolean) {
        useLayout().isRightSidebarOpen = value;
      },
    },
  },
});
